import { gql } from '@apollo/client';
import { FILE, FUNDER, INSTITUTION, INTERVENTION, PROGRAMME, REPORT, SERVICE_PROVIDER, USER } from '../fragments';

export const GET_REPORT = gql`
  query GetReport($reportId: ID!) {
    report: getReport(reportId: $reportId) {
      ...report
      funder {
        ...funder
      }
      createdBy {
        ...user
      }
      institutions {
        ...institution
      }

      interventions {
        ...intervention
      }
      programmes {
        ...programme
      }
      serviceProvider {
        ...serviceProvider
      }
      files {
        ...file
      }
    }
  }
  ${REPORT}
  ${USER}
  ${INSTITUTION}
  ${INTERVENTION}
  ${PROGRAMME}
  ${SERVICE_PROVIDER}
  ${FILE}
  ${FUNDER}
`;
